// extracted by mini-css-extract-plugin
export default {"btnChangeResponsible":"dayOffInProgress_btnChangeResponsible__wAddw","hide":"dayOffInProgress_hide__Jstgo","changeResponsible":"dayOffInProgress_changeResponsible__nnG+-"};